import { render } from "./AlertTemp.vue?vue&type=template&id=8f9948ae&scoped=true"
import script from "./AlertTemp.vue?vue&type=script&lang=js"
export * from "./AlertTemp.vue?vue&type=script&lang=js"

import "./AlertTemp.vue?vue&type=style&index=0&id=8f9948ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f9948ae"]])

export default __exports__